<template>
  <div class="steps">
    <div class="step-descripton">
      {{ steps[stepsIndex] }}
    </div>
    <div class="step-container">
        <Step1 class="animate__animated animate__fadeIn animate__faster" @nextStep="nextStep" :isShow="stepsIndex === 0" v-show="stepsIndex === 0" />
        <Step2 class="animate__animated animate__fadeIn animate__faster" @nextStep="nextStep" :isShow="stepsIndex === 1" v-if="stepsIndex === 1" />
        <Step3 class="animate__animated animate__fadeIn animate__faster" @nextStep="nextStep" :isShow="stepsIndex === 2" v-if="stepsIndex === 2" />
        <Step4 class="animate__animated animate__fadeIn animate__faster" @nextStep="nextStep" :isShow="stepsIndex === 3" v-if="stepsIndex === 3" />
        <Step5 class="animate__animated animate__fadeIn animate__faster" @nextStep="nextStep" :isShow="stepsIndex === 4" v-if="stepsIndex === 4" />
        <Step6 class="animate__animated animate__fadeIn animate__faster" @nextStep="nextStep" :isShow="stepsIndex === 5" v-if="stepsIndex === 5" />
    </div>
  </div>
</template>

<script>
import Step1 from './step1'
import Step2 from './step2'
import Step3 from './step3'
import Step4 from './step4'
import Step5 from './step5'
import Step6 from './step6'
export default {
  components: {
    Step1,
    Step2,
    Step3,
    Step4,
    Step5,
    Step6
  },
  data () {
    return {
      steps: ['第一步：输入心动 ID', '第二步：阅读账号注销细则', '第三步：阅读账号注销协议', '第四步：验证本账号实名验证时的信息', '第五步：确认删除的游戏号', '第六步：注销心动账号申请，提交成功'],
      stepsIndex: 0,
      margin: {
        margin: '80px'
      }
    }
  },
  mounted () {
    this.routerGuard()
  },
  methods: {
    nextStep () {
      this.stepsIndex++
      this.$router.push({ name: 'Home', hash: `#step${this.stepsIndex + 1}`, params: { index: this.stepsIndex + 1 } })
    },
    routerGuard () {
      this.$router.afterEach((to, from) => {
        const index = Number(to.hash.replace('#step', ''))
        if (index > 0) {
          this.stepsIndex = index - 1
        }
        // ...
      })
    }
  }

}
</script>

<style lang="less" scoped>
@media screen and (max-width: 1280px){

}
@media screen and (min-width: 1280px){
    .steps{
        // margin: 80px;
        margin-top: 80px;
        margin-bottom: 80px;
    }
}
.steps {
  .step-descripton {
    height: 26px;
    left: 20px;
    top: 176px;
    text-align: left;
    font-family: PingFang SC;
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 26px;
    color: #333333;
  }
}
</style>
